import { useContext } from "react";

import { Theme, useMediaQuery } from "@mui/material";

import { DeviceDimensionsOverrideContext } from "../contexts/DeviceDimensions";

/**
 * Defines how we access the device dimensions,
 * and what we define as a mobile device vs a larger device.
 */
export const useDeviceDimensions = () => {
  const context = useContext(DeviceDimensionsOverrideContext);

  const isLargeScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("md")
  );

  // an override context is available, use that instead
  if (context) {
    return context;
  }

  return { isLargeScreen, isMobile: !isLargeScreen };
};
